// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Background_wrapper__24Zd8","animation":"Background_animation__PWw7z","foreground-animation":"Background_foreground-animation__2cELi"};